import React, { useEffect } from 'react';
import Lottie from 'lottie-web';
import logoutAnimationLottie from '../../assets/lottie/LogoutAnimation.json';
import logoutStyles from './logout.scss';

const LogoutAnimation = () => {
  useEffect(() => {
    Lottie.loadAnimation({
      name: 'LogoutAnimation',
      animationData: logoutAnimationLottie,
      container: document.querySelector('#LogoutAnimation'),
    });

    return () => Lottie.destroy('LogoutAnimation');
  }, []);

  return (
    <div
      id="LogoutAnimation"
      className={logoutStyles.logoutAnimation}
    />
  );
};

export default LogoutAnimation;
